// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".account-dash {\n  height: 70vh;\n}", "",{"version":3,"sources":["webpack://src/scenes/userAccountManager/styles.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF","sourcesContent":[".account-dash {\n  height: 70vh;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
